export class Column {
  colName: string;
}
